import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const OrderType = {
  DINE_IN: "DINE_IN",
  TAKE_OUT: "TAKE_OUT",
  DELIVERY: "DELIVERY",
};

const MenuValidationSchema = yup.object().shape(
  {
    name: yup.string().required(),
    phoneNumber: yup
      .string()
      .required()
      .when("phoneNumber", {
        is: (val) => val?.length,
        then: yup
          .string()
          .matches(/^[0-9]+$/, "Phone number must contain only digits")
          .test(
            "num",
            "Invalid phone number format",
            (val) => !val.startsWith("0"),
          )
          .min(9, "Invalid phone number format")
          .max(11, "Invalid phone number format"),
      }),
    email: yup
      .string()
      .required()
      .nullable("Email is required")
      .email("Invalid email address")
      .max(40, "Maximum of 30 characters is allowed"),
    orderType: yup.mixed().oneOf(Object.values(OrderType)),
    country: yup.string().when("orderType", {
      is: OrderType.DELIVERY,
      then: yup.string().required("Country is a required field"),
      otherwise: yup.string().notRequired(),
    }),
    state: yup.string().when("orderType", {
      is: OrderType.DELIVERY,
      then: yup.string().required("This field is required"),
      otherwise: yup.string().notRequired(),
    }),
    streetAddress: yup.string().when("orderType", {
      is: OrderType.DELIVERY,
      then: yup.string().required("This field is required"),
      otherwise: yup.string().notRequired(),
    }),
    scheduleTime: yup.string().when(["orderType", "menuObjectDetail"], {
      is: (orderType, menuObjectDetail) =>
        orderType === OrderType.DELIVERY &&
        menuObjectDetail?.allow_scheduled_delivery,
      then: yup.string().required("This field is required"),
      otherwise: yup.string().notRequired(),
    }),
  },
  ["phoneNumber", "phoneNumber"],
);

const Validation = (
  name,
  email,
  phoneNumber,
  country,
  state,
  streetAddress,
  orderType,
  scheduleTime,
  menuObjectDetail,
) => {
  return useForm({
    resolver: yupResolver(MenuValidationSchema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      name,
      email,
      phoneNumber,
      country,
      state,
      streetAddress,
      orderType,
      scheduleTime: scheduleTime || "",
      menuObjectDetail,
    },
  });
};

export default Validation;
